import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const BuscadorHallazgosService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Hallazgo/BuscadorHallazgos",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { BuscadorHallazgosService };